module.exports = __WEBPACK_EXTERNAL_MODULE_14__;


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 14
// module chunks = 0